/**
 * Classe responsável por rejeitar todos os itens selecionados.
 *
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 30/07/2013
 *
 */


Greenmile.ServiceTimeUpdates = Greenmile.ServiceTimeUpdates || {};

Greenmile.ServiceTimeUpdates.RejectAll = (function () {

    RejectAll.prototype = new Monet.Grid.ActionsModules.ButtonEventCheckBox();

        function RejectAll () {

        this.setValueBtn = function () {
            var value = Monet.I18n.getResourcesByKey("Greenmile.ServiceTimeUpdates.btnRejectAll");
            this.valueBtn = value;
        };

        this.actionAfterClickButton = function () {

            var error = null;

            try {

                const confirmRejectAll = () => {
                    App.Objects.ServiceTimeUpdates.rejectAll();
                };

                new Greenmile.Components.AlertModal("Greenmile.ServiceTimeUpdates.confirmRejectAll",
                    null,
                    confirmRejectAll)
                .show();


            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    "Error on action after click button on reject all.");
                error.console();

            }

        };

        this.initialize = function (entity) {

            this.setEntity(entity);
            this.setSelector("#ServiceTimeUpdates .gridHeaderContainer .rightContainer");
            this.setScreenName("#ServiceTimeUpdates");
            this.setValueBtn();
            this.setId("btnRejectAll");
            this.setBtnSelector('#ServiceTimeUpdates #btnRejectAll');
            this.init();
        };

    }

    return RejectAll;

})();
